module.exports = __webpack_public_path__ + "static/media/26@2x.55fb85ee.png";